define("PDPModifications.View", [
  "SCView",
  "sdb_pdpmodifications_template.tpl",
], function (SCViewComponent, pdpmodifications_tpl) {
  "use strict";

  var SCView = SCViewComponent.SCView;

  function SDBPDPModificationsView(options) {
    try {
      SCView.call(this);

      this.options = options;
      this.template = pdpmodifications_tpl;
      this.itemInfo = this.options.itemInfo;

      this.attributes = {
        id: "SDBPDPModificationsViewId",
        class: "sdb-pdp-modifications-view",
      };

      this.getContext = function () {
        var item = this.itemInfo.item;
        var strStoreDescription = item.storedescription;

        return {
          storedescription: strStoreDescription,
        };
      };
    } catch (error) {
      console.log(error);
    }
  }

  SDBPDPModificationsView.prototype = Object.create(SCView.prototype);
  SDBPDPModificationsView.prototype.constructor = SDBPDPModificationsView;

  return SDBPDPModificationsView;
});
